import { Component, HostListener, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";
import { defaultIfEmpty } from "rxjs/operators";
import { MisClientesSandbox } from "../mis-clientes.sandbox";
import { Paginacion } from "../../../models/paginacion/paginacion.model";
import { BuscarClienteComponent } from "../shared/components/buscar-cliente/buscar-cliente.component";

@Component({
  selector: "app-mis-clientes",
  templateUrl: "./mis-clientes.component.html",
  styleUrls: ["./mis-clientes.component.css"],
})
export class MisClientesComponent implements OnInit {
  clientes: any[];
  paginacion: Paginacion;
  buscandoClientes: Boolean = false;

  tiposDocumento: any[];

  displayedColumns = ["tipoDocumentoDesc", "numeroDocumento", "nombre", "celular"];
  selectedRowId: number;
  showScrollHeight: number;
  hideScrollHeight: number;
  showGoUpButton: boolean;

  constructor(
    private misClientesSandbox: MisClientesSandbox,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.misClientesSandbox
      .buscarTiposDocumento()
      .subscribe((res) => (this.tiposDocumento = res));

    this.misClientesSandbox.capturarDetalleNavbar().subscribe((res) => {
      if (res !== "0") {
        this.initClientes();
      }
    });
  }

  private initClientes() {
    this.selectedRowId = -1;
    this.showScrollHeight = 400;
    this.hideScrollHeight = 200;
    this.showGoUpButton = false;

    this.paginacion = {
      pagina: 0,
      filasPorPagina: 100,
      columnaOrdenamiento: "dniTomador",
      direccionOrdenamiento: -1,
    } as Paginacion;

    this.buscandoClientes = true;
    this.misClientesSandbox
      .getClientes(this.paginacion)
      .pipe(defaultIfEmpty([]))
      .subscribe((res) => {
        this.clientes = res;
        this.findTipoDocumentoDescription();
        this.buscandoClientes = false;
      });
  }

  onScroll() {
    if (this.buscandoClientes) return false;
    this.buscandoClientes = true;
    this.paginacion.pagina++;
    this.misClientesSandbox
      .getCotizacionesByPage(this.paginacion)
      .subscribe((res) => {
        this.clientes = this.clientes.concat(res);
        this.findTipoDocumentoDescription();
        this.buscandoClientes = false;
      });
  }

  private findTipoDocumentoDescription() {
    this.clientes.map((cliente) => {
      let tipoDoc = this.tiposDocumento.find(
        (tipo) => tipo.id == cliente.tipoDocumento
      );
      cliente.tipoDocumentoDesc = tipoDoc ? tipoDoc.descripcion : cliente.id;
    });
  }

  scrollTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    let isScrollUp = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    let isScrollDown = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

    if (isScrollUp > this.showScrollHeight) {
      this.showGoUpButton = true;
    } else if (this.showGoUpButton && isScrollDown < this.hideScrollHeight) {
      this.showGoUpButton = false;
    }
  }

  refrescar() {
    this.initClientes();
  }

  openDialogBuscar() {
    let dialogRef = this.dialog.open(BuscarClienteComponent, {
      width: "450px",
      data: {
        tiposDocumento: this.tiposDocumento
      }
    });

    dialogRef.afterClosed().subscribe((filtros) => {
      if (filtros && Object.keys(filtros).length !== 0) {
        this.paginacion.pagina = 0;
        this.misClientesSandbox
          .filtrarCotizaciones(filtros, this.paginacion)
          .subscribe((res) => {
            this.clientes = res;
            this.findTipoDocumentoDescription();
          });
      }
    });
  }

  verCliente(clienteSelected) {
    this.selectedRowId = clienteSelected.id;
    this.misClientesSandbox.redirigir(clienteSelected);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/mis-clientes/pages/mis-clientes.component.ts